import React from 'react';

export const _LoadingContext = React.createContext({});
export const LoadingProvider = _LoadingContext.Provider;
export const LoadingConsumer = _LoadingContext.Consumer;
export const LoadingContext = _LoadingContext;
